import { TwoFactorAuthMethod } from "@ifgengineering/client-auth-sdk";
import React, { FC } from "react";
import MagicCodeForm from "./MagicCodeForm";

interface MagicCodeProps {
  loginRedirect: string;
  handleCancel: () => void;
  method?: TwoFactorAuthMethod;
  customErrorMessage?: string;
  email?: string;
}

const MagicCode: FC<MagicCodeProps> = ({
  handleCancel,
  loginRedirect,
  method,
  customErrorMessage,
  email = "",
}) => {
  return (
    <MagicCodeForm
      loginRedirect={loginRedirect}
      email={email}
      handleBackButton={handleCancel}
      method={method}
      customErrorMessage={customErrorMessage}
    />
  );
};

export default MagicCode;
